import { DrawBufferContext } from "./buffer/buffer"
import { EditFeature } from "./edit-feature"

export function getZoneDimensions(zone: EditFeature, marginCtxt: DrawBufferContext) {

    if (zone) {

        const dim = marginCtxt.isActive()
            ? marginCtxt.getCurrentDimensions()
            : zone.getCurrentDimensions()

        return {
            area: dim.area && (Math.round(dim.area / 100) / 100),
            length: (!zone.isCircle()) && dim.length && Math.round(dim.length)
        }

    }

}
